import type { FormField } from './form-types';

// Base configuration that all shaders share
export interface BaseShaderConfig {
  width: number;
  height: number;
  referenceWidth?: number;
  referenceHeight?: number;
  rotation?: number;
}

// Base form fields that appear in all shader forms
export const BASE_FORM_CONFIG: FormField[] = [
  {
    type: 'range',
    name: 'width',
    label: 'Width',
    description: 'Canvas width in pixels',
    min: 100,
    max: 2000,
    step: 50,
    defaultValue: 512,
    colspan: 1,
  },
  {
    type: 'range',
    name: 'height',
    label: 'Height',
    description: 'Canvas height in pixels',
    min: 100,
    max: 2000,
    step: 50,
    defaultValue: 512,
    colspan: 1,
  },
  {
    type: 'range',
    name: 'referenceWidth',
    label: 'Reference Width',
    description: 'Animation reference width (keeps animation size consistent)',
    min: 100,
    max: 1500,
    step: 25,
    defaultValue: 512,
    colspan: 1,
  },
  {
    type: 'range',
    name: 'referenceHeight',
    label: 'Reference Height',
    description: 'Animation reference height (keeps animation size consistent)',
    min: 100,
    max: 1500,
    step: 25,
    defaultValue: 512,
    colspan: 1,
  },
  {
    type: 'range',
    name: 'rotation',
    label: 'Rotation',
    description: 'Rotate the shader in degrees',
    min: 0,
    max: 360,
    step: 1,
    defaultValue: 0,
    colspan: 2,
  },
];
